import { api } from '@rd-web-markets/shared/dist/services/service';
const sicCodeSectionService = {
  get: function () {
    let queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return api.get(`/sic_codes/sections?${queryParams}`);
  }
};
export default sicCodeSectionService;